<div class="content-with-filled-button">
    <form class="row" id="independentForm">
        <div class="main col-4 col-pr-12 col-sm-4 col-md-6 col-lg-6 col-xl-6">
            <h1 class="sub-title" id="generalTitle">
                {{ copyService.copies.independent_occupation.general_title }}
                <vcl-additional-info class="info-icon"
                    [text]="copyService.copies.independent_occupation.additional_information_text" position="down-left"
                    id="addtionalInformationId" a11yLabelButton="ciiuCode" (click)="clickInfo()"></vcl-additional-info>
            </h1>
            <div class="div-activity">
                <voxel-form-field id="ciiuGeneralSelectionLabel"
                [label]="copyService.copies.independent_occupation.economic_general_activities_title">
                    <vcl-autocomplete id="inputValueOccupationGeneral"
                        [placeholder]="copyService.copies.independent_occupation.ciiu_general_selection_text"
                        [notFoundTitle]="copyService.copies.independent_occupation.not_found_title"
                        [notFoundMessage]="copyService.copies.independent_occupation.not_found_message"
                        (change)="selectOptionCiiu($event)" required>
                        <vcl-option *ngFor="let option of optionsCiiu" [value]="option"
                            [selected]="selectedGeneral.ciiu === option.ciiu">
                            {{ option.ciiu }} - {{ option.description }}
                        </vcl-option>
                    </vcl-autocomplete>
                </voxel-form-field>
            </div>
            <voxel-form-field *ngIf="enableDetail" id="ciiuSelectionLabel"
                [label]="copyService.copies.independent_occupation.economic_activities_title">
                <vcl-autocomplete id="inputValueOccupation"
                    [placeholder]="copyService.copies.independent_occupation.ciiu_selection_text"
                    [notFoundTitle]="copyService.copies.independent_occupation.not_found_title"
                    [notFoundMessage]="copyService.copies.independent_occupation.not_found_message"
                    (change)="selectOption($event)" required>
                    <vcl-option *ngFor="let option of options" [value]="option"
                        [selected]="selectedCiiu.ciiu === option.ciiu">
                        {{ option.large_description }}
                    </vcl-option>
                </vcl-autocomplete>
            </voxel-form-field>
            <div *ngIf="selectedProduct.name === 'CreditTarget' || selectedProduct.name === 'revolvingCredit' || selectedProduct.name === 'freeInvestment' || selectedProduct.name === 'livingPlace' || selectedProduct.name === 'revolvingCredit2'|| selectedProduct.name === 'CreditTarget2'|| selectedProduct.name === 'freeInvestment2' || selectedProduct.name === 'MultiProduct'" > 
                <h1 class="sub-title sub-title--date" id="generalTitle">
                    {{ copyService.copies.independent_occupation.activity_start_date }}
                </h1>
                <vcl-datepicker language="es" [dateLabel]="copyService.copies.independent_occupation.date_of_beginning"
                    (keyup) = "validReactiveInput($event)"    
                    (change)="enableContinue()"
                    [invalidDateErrorMessage]="copyService.copies.independent_occupation.selected_date_error"
                    [(selectedDate)]="selectedDate" [required]="true"></vcl-datepicker>
                <div *ngIf="selectedProduct.flow != 'livingPlace'" class="note">{{ copyService.copies.independent_occupation.selected_date_error }}</div>
            </div>
        </div>
    </form>
</div>
<app-controls id="independentOccupationBtns" [nextLabel]="copyService.copies.independent_occupation.next_button_text"
    [nextDisabled]="!isBtnDisabled" (next)="next()"></app-controls>